<template>
  <div></div>
  <!-- <div class="notification-bar" :class="notificationTypeClass">
    {{ notification.message }}
  </div> -->
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000) //this will remove notification after 5s is mounted//
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
  computer: {
    notificationTypeClass() {
      return `-text-${this.notification.type}`
    }
  },
  methods: mapActions('notification', ['remove'])
}
</script>

<style scoped>
.notification-bar {
  margin: 1em 0 1em;
}
</style>
